/* eslint-disable react/no-multi-comp */

import React from 'react'
import { FormattedMessage } from 'react-intl'

export const LEAVING_CLAN = <FormattedMessage id="clan_leaving.layout.leaving_clan" defaultMessage="Покинуть клан " />
export const COOLDOWN = time => (
    <FormattedMessage
        id="clan_leaving.layout.cooldown"
        defaultMessage="После выхода из клана вы сможете вступить в клан через {time}{nbsp}ч."
        values={{
            time,
            nbsp: <span>&nbsp;</span>,
        }}
    />
)

export const JOURNAL_TOOLTIP = (
    <FormattedMessage
        id="clan_leaving.layout.journal_tooltip"
        defaultMessage="Нажмите, чтобы просмотреть прошедшие события в Укрепрайоне."
    />
)

export const LEAVING_BUTTON = (
    <FormattedMessage id="clan_leaving.layout.leaving_button" defaultMessage="Покинуть клан" />
)

export const CANCEL_BUTTON = <FormattedMessage id="clan_leaving.layout.cancel_button" defaultMessage="Отменить" />

export const CLOSE_BUTTON = <FormattedMessage id="clan_leaving.layout.close_button" defaultMessage="ЗАКРЫТЬ" />



// WEBPACK FOOTER //
// ./containers/ClanLeaving/components/ClanLeavingLayout/constants.jsx